import { type KeyboardEvent } from "react";

import Reset from "atoms/icon/icons/ic_close_small_ol.svg";
import Search from "atoms/icon/icons/ic_search.svg";
import { TextField } from "atoms/text-field/TextField";

type Props = {
  className?: string;
  placeholder?: string;
  label?: string;
  value?: string;
  disabled?: boolean;
  name?: string;
  onChange?: (value: string) => void;
  autoFocus?: boolean;
  pattern?: string;
  onBlur?: (value: string) => void;
  onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;

  /** Handler that is called when either the left or right icons are clicked */
  onIconClick?: (side: "left" | "right") => void;

  /** Specify the testid for current component */
  "data-testid"?: string;
};

export const SearchFieldV3 = ({
  name,
  value,
  onChange,
  disabled = false,
  onIconClick,
  placeholder,
  label,
  autoFocus = false,
  pattern,
  onBlur,
  onKeyDown,
  "data-testid": dataTestId,
}: Props) => {
  return (
    <label className="relative block grow text-body1 text-secondary">
      <Search
        className="absolute left-3 top-[50%] mt-1 h-6 w-6 -translate-y-1/2 cursor-pointer fill-[theme(textColor.secondary)]"
        onClick={() => onIconClick?.("left")}
      />
      <TextField
        className="max-h-10"
        leftIcon={Search}
        type="search"
        label={label}
        labelClassName="!hidden peer-focus:!hidden"
        placeholderClassName="!top-[50%] !-translate-y-1/2 mt-1"
        onChange={(value: string) => onChange?.(value)}
        value={value}
        name={name}
        pattern={pattern}
        data-testid={dataTestId}
        autoFocus={autoFocus}
        placeholder={placeholder}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        disabled={disabled}
        inputMode="search"
      />
      {value && (
        <Reset
          className="absolute right-3 top-[50%] mt-1 h-6 w-6 -translate-y-1/2 cursor-pointer fill-[theme(textColor.secondary)] peer-aria-invalid:fill-red"
          onClick={() => onIconClick?.("right")}
        />
      )}
    </label>
  );
};
